import styles from "./square.module.css"

export default function Square2125() {
  return <div className={styles.square2125}></div>
}
